import React, { useEffect, useState } from "react";
import {
  getTestimonials,
  deleteTestimonial,
  updateTestimonial,
} from "../utils/firebaseCRUD";
import { uploadToCloudinary } from "../utils/cloudinaryUpload";
import "./TestimonialManager.css";

function TestimonialManager() {
  const [items, setItems] = useState([]);
  const [editId, setEditId] = useState(null);
  const [form, setForm] = useState({ name: "", stars: "", description: "" });
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [query, setQuery] = useState("");

  // 🔹 Load all testimonials from Firestore
  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    const data = await getTestimonials();
    setItems(data);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this review?")) {
      await deleteTestimonial(id);
      await loadData();
    }
  };

  const handleEdit = (item) => {
    setEditId(item.id);
    setForm({
      name: item.name,
      stars: item.stars,
      description: item.description,
    });
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      let personImageUrl;
      if (image) personImageUrl = await uploadToCloudinary(image);

      const updatedData = {
        name: form.name,
        stars: Number(form.stars),
        description: form.description,
      };

      if (personImageUrl) updatedData.personImageUrl = personImageUrl;

      await updateTestimonial(editId, updatedData);

      setEditId(null);
      setForm({ name: "", stars: "", description: "" });
      setImage(null);
      await loadData();
      alert("Testimonial updated successfully!");
    } catch (err) {
      console.error(err);
      alert("Error updating testimonial");
    }
    setLoading(false);
  };

  const filtered = items.filter(i => i.name.toLowerCase().includes(query.toLowerCase()) || (i.description||"").toLowerCase().includes(query.toLowerCase()));

  return (
    <div className="testimonial-manager-container">
      <div className="manager-header">
        <h2 className="testimonial-manager-title">Manage Testimonials</h2>
        <div className="manager-actions">
          <input type="search" placeholder="Search reviews" value={query} onChange={e=>setQuery(e.target.value)} />
        </div>
      </div>

      {/* Edit Form */}
      {editId && (
        <form className="testimonial-edit-form" onSubmit={handleUpdate}>
          <input type="text" placeholder="Name" value={form.name} onChange={(e)=>setForm({...form, name:e.target.value})} required />
          <input type="number" placeholder="Stars (1-5)" value={form.stars} onChange={(e)=>setForm({...form, stars:e.target.value})} required />
          <textarea placeholder="Description" value={form.description} onChange={(e)=>setForm({...form, description:e.target.value})} required />
          <input type="file" accept="image/*" onChange={(e)=>setImage(e.target.files[0])} />
          <div className="form-actions">
            <button type="submit" disabled={loading} className="btn primary">{loading? 'Updating...':'Save Changes'}</button>
            <button type="button" className="btn ghost" onClick={()=>{ setEditId(null); setForm({name:'',stars:'',description:''}); setImage(null); }}>Cancel</button>
          </div>
        </form>
      )}

      {/* List All Testimonials */}
      <div className="testimonial-list">
        {filtered.length === 0 && <p>No testimonials yet!</p>}
        {filtered.map((item) => (
          <div key={item.id} className="testimonial-item">
            <img src={item.personImageUrl} alt={item.name} className="testimonial-image" />
            <div className="testimonial-details">
              <h4>{item.name}</h4>
              <p className="stars">{Array.from({length:5}).map((_,i)=> <span key={i} className={i<item.stars? 'star active':'star'}>★</span>)}</p>
              <p className="testimonial-desc">{item.description}</p>
            </div>
            <div className="testimonial-actions">
              <button onClick={() => handleEdit(item)} className="icon-btn edit" aria-label={`Edit ${item.name}`}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25z" fill="currentColor"/><path d="M20.71 7.04a1 1 0 0 0 0-1.41l-2.34-2.34a1 1 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" fill="currentColor"/></svg>
              </button>
              <button onClick={() => handleDelete(item.id)} className="icon-btn delete" aria-label={`Delete ${item.name}`}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 6h18" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/><path d="M8 6v12a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/><path d="M10 11v6M14 11v6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/></svg>
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default TestimonialManager;